import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: '',
    button:
      'fixed right-4 bottom-52 z-10 cursor-pointer rounded-[20px] bg-white/70 p-2 [box-shadow:0_0_12px_0_rgba(0,0,0,0.07)] [backdrop-filter:blur(20px)] lg:bottom-26',
    preview:
      'h-[120px] max-h-[120px] w-[120px] overflow-hidden rounded-full border-1 border-white object-cover text-center lg:h-[150px] lg:max-h-[150px] lg:w-[150px]',
    title: 'heading-xs-bold lg:heading-s-bold mt-2 text-center',
    close:
      'bg-blue-dark flex-center absolute top-3 right-3 flex h-6 w-6 cursor-pointer rounded-full p-0 text-white',
    modal:
      'flex h-full flex-col !px-0 !pb-2 lg:min-h-150 lg:min-w-160 lg:flex-row lg:!py-0',
    leftWrapper: 'flex h-full w-full flex-col lg:h-auto lg:w-1/2',
    videoWrapper: 'flex h-full w-full items-center justify-center bg-black',
    video: 'relative flex-1 overflow-hidden',
    videoExpert: 'max-lg:max-h-[50vh]',
    soundButton:
      'flex-center heading-s absolute top-5 left-5 z-10 mx-auto flex max-w-fit cursor-pointer gap-2 rounded-full px-3 py-3 normal-case lg:top-auto lg:right-0 lg:bottom-8 lg:left-0 lg:py-2',
    soundButtonText: 'max-lg:hidden',
    content:
      'flex h-full w-full flex-col justify-between px-3 pt-10 lg:h-auto lg:w-1/2 lg:px-13 lg:pb-12',
    topDesktop: 'hidden flex-col gap-1 lg:flex',
    topMobile: 'mb-8 flex flex-col gap-1 px-5 lg:mb-12 lg:hidden',
    productTitle: 'heading-m',
    heading: 'heading-3xl mb-1 max-lg:mt-2',
    bottom: 'max-lg:flex max-lg:gap-5',
    avatar:
      'max-h-20 min-h-20 min-w-20 overflow-hidden rounded-full object-cover lg:mb-5',
    name: 'heading-s-bold mb-1',
    job: 'heading-xs',
    avatarWrap: '',
    info: ''
  },
  variants: {
    muted: {
      true: {
        soundButton: 'bg-white text-black'
      },
      false: {
        soundButton: 'bg-blue-dark text-white'
      }
    }
  },
  defaultVariants: {
    muted: false
  }
});
